import { InjectionToken } from '@angular/core';
import { DurationUnit } from '@lx/shared/data-access/types';

type DurationPlurality = 'singular' | 'plural';

export const DURATION_TOKENS = new InjectionToken<Record<DurationPlurality, Record<DurationUnit, string>>>('DURATION_TOKENS', {
  providedIn: 'root',
  factory: () => ({
    singular: {
      EACH: $localize`lesson`,
      HOURS: $localize`hour`,
      WEEKS: $localize`week`,
      DAYS: $localize`day`,
      MONTH: $localize`month`,
      YEARS: $localize`year`,
      LESSONS: $localize`lesson`,
    },
    plural: {
      EACH: $localize`lessons`,
      HOURS: $localize`hours`,
      WEEKS: $localize`weeks`,
      DAYS: $localize`days`,
      MONTH: $localize`months`,
      YEARS: $localize`years`,
      LESSONS: $localize`lessons`,
    },
  }),
});
